// ============================================================================
// OBT F2-B — ACL'li fotoğraf küçük görseli (blob + Object URL temizliği)
// ============================================================================
// Fotoğraf, ACL'li uçtan blob olarak alınır (ham storage yolu/URL kullanılmaz).
// Object URL, unmount veya photo değişiminde `revokeObjectURL` ile serbest
// bırakılır. Görüntülenemeyen fotoğraf formu ÇÖKERTMEZ; nötr yer tutucu gösterir.
// ============================================================================

import { useEffect, useRef, useState } from 'react';
import { ImageOff, Loader2 } from 'lucide-react';
import { readResponsePhoto } from './mediaApi';

/**
 * @param {object} props
 * @param {string} props.responseId
 * @param {string} props.photoId
 * @param {string} [props.alt]
 */
export default function PhotoThumb({ responseId, photoId, alt = 'Yüklenen fotoğraf' }) {
  const [state, setState] = useState({ loading: true, url: null, failed: false });
  const urlRef = useRef(null);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setState({ loading: true, url: null, failed: false });
    readResponsePhoto(responseId, photoId, { signal: controller.signal })
      .then(({ objectUrl }) => {
        if (!active) {
          URL.revokeObjectURL(objectUrl);
          return;
        }
        urlRef.current = objectUrl;
        setState({ loading: false, url: objectUrl, failed: false });
      })
      .catch((e) => {
        if (!active || e?.name === 'CanceledError' || e?.code === 'ERR_CANCELED') return;
        setState({ loading: false, url: null, failed: true });
      });
    return () => {
      active = false;
      controller.abort();
      if (urlRef.current) {
        URL.revokeObjectURL(urlRef.current);
        urlRef.current = null;
      }
    };
  }, [responseId, photoId]);

  if (state.loading) {
    return (
      <div className="flex h-20 w-20 items-center justify-center rounded-md bg-gray-100">
        <Loader2 className="h-4 w-4 animate-spin text-gray-400" aria-hidden="true" />
        <span className="sr-only">Fotoğraf yükleniyor</span>
      </div>
    );
  }
  if (state.failed || !state.url) {
    return (
      <div
        className="flex h-20 w-20 flex-col items-center justify-center gap-1 rounded-md bg-gray-100 text-gray-400"
        role="img"
        aria-label="Fotoğraf görüntülenemedi"
      >
        <ImageOff className="h-4 w-4" aria-hidden="true" />
        <span className="text-[10px]">Yok</span>
      </div>
    );
  }
  return (
    <img
      src={state.url}
      alt={alt}
      className="h-20 w-20 rounded-md object-cover ring-1 ring-inset ring-gray-200"
    />
  );
}
